import { LegalPage } from "@/pages/LegalPage";

const H = ({ children }) => (
  <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-white">{children}</h2>
);

const ServiceDisclaimer = () => (
  <LegalPage
    title="Service Disclaimer"
    description="Service disclaimer for Freedom Mobile Auto Detailing — starting prices, stain removal, scheduling, and appointment details for mobile detailing in Gap, PA."
    path="/service-disclaimer"
    updated="July 2026"
    testId="service-disclaimer-page"
  >
    <section>
      <H>Pricing</H>
      <p className="mt-3">
        Pricing displayed on this website represents starting prices. Final pricing can depend on vehicle size and
        condition — including excessive dirt, stains, pet hair, or the amount of time required. Any pricing
        difference will be communicated before work begins.
      </p>
    </section>
    <section>
      <H>Stains &amp; Condition</H>
      <p className="mt-3">
        We use extraction and stain-cleaning methods when needed, but stain removal cannot be guaranteed. Some
        permanent or deeply set stains may not be completely removable.
      </p>
    </section>
    <section>
      <H>Before Your Appointment</H>
      <p className="mt-3">
        Please remove valuable personal belongings from your vehicle before service. Any existing vehicle damage
        should be disclosed before service begins.
      </p>
    </section>
    <section>
      <H>Availability</H>
      <p className="mt-3">
        Service availability depends on scheduling, location, weather, and working conditions. We'll always confirm
        the details of your appointment with you directly.
      </p>
    </section>
  </LegalPage>
);

export default ServiceDisclaimer;
